import React, { useState,useEffect } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import { CustomerTable } from "./CustomerTable";
import { useSelector, useDispatch } from "react-redux";
import {
  resetData,
  selectCustomer,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchCustomer,
} from "./customerSlice";

export const CustomerPage = () => {
  const dispatch = useDispatch();
  const customer = useSelector(selectCustomer);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);

  
  useEffect(() => {
    // Reset on first load
    dispatch(resetData());
  }, [dispatch]);


  // Filter
  const [customerCode, setCustomerCode] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [NPWP, setNPWP] = useState("");
  const [customerGroup1, setCustomerGroup1] = useState("");
  const [customerGroup2, setCustomerGroup2] = useState("");

  const handleSearch = () => {
    const params = {
      customerCode: customerCode,
      customerName: customerName,
      group1: customerGroup1,
      group2: customerGroup2,
      npwp: NPWP,
      pageNo: pageNo,
      pageSize: pageSize,
    };
    console.log("params", params);
    dispatch(fetchCustomer(params));
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    const params = {
      customerCode: customerCode,
      customerName: customerName,
      group1: customerGroup1,
      group2: customerGroup2,
      npwp: NPWP,
      pageNo: page,
      pageSize: sizePerPage,
    };
    console.log("params", params);
    dispatch(fetchCustomer(params));
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="Customer"></CardHeader>
      <CardBody>
        <Form>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Customer Code</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Customer Code"
                    onChange={(e) => {
                      setCustomerCode(e.target.value);
                    }}
                    value={customerCode}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Customer Name</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Customer Name"
                    onChange={(e) => {
                      setCustomerName(e.target.value);
                    }}
                    value={customerName}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>NPWP</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="NPWP"
                    onChange={(e) => {
                      setNPWP(e.target.value);
                    }}
                    value={NPWP}
                  />
                </Col>
              </Form.Group>
            </Col>

            {/* Right Row */}
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Customer Group 1</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="number"
                    placeholder="Customer Group 1"
                    onChange={(e) => {
                      setCustomerGroup1(e.target.value);
                    }}
                    value={customerGroup1}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Customer Group 2</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Customer Group 2"
                    onChange={(e) => {
                      setCustomerGroup2(e.target.value);
                    }}
                    value={customerGroup2}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Col>
              <Button className="btn btn-primary" onClick={handleSearch}>
                Search
              </Button>
            </Col>
          </Form.Group>
        </Form>

        {/* Table */}
        {customer.length > 0 && (
          <CustomerTable
            data={customer}
            page={pageNo}
            sizePerPage={pageSize}
            totalSize={totalRecord}
            onTableChange={handleTableChange}
            loading={loading}
          />
        )}
      </CardBody>
    </Card>
  );
};
